import React from "react";
import { NavBar } from "./NavBar";
import Logo from "../assets/simbol-Pillar.webp";

import PillarSide from "../assets/Pillar-Side.webp";

export function Footer({ onOpenModal }) {
  return (
    <footer className="footerContainer">
      <span>Copyright ©2025 Pillar Hydraulics</span>
      <div className="footerPhoneContainer smallText">
        <span className="smallText">call us now</span>
        <span className="smallText yellowTextHighlight">+1 403 606 7586</span>
      </div>
    </footer>
  );
}
